// FAKE DATA
export const books = [
  {
    id: 1,
    title: "Crack the Coding Interview",
    url: "https://m.media-amazon.com/images/I/61mIq2iJUXL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 49.95,
    salePrice: 14.95,
    rating: 4.5,
    description:
      "Crack the Coding Interview is a comprehensive guide for software engineers preparing for technical interviews. It covers data structures, algorithms, system design, and problem-solving strategies commonly tested by top tech companies. Each chapter includes real interview questions with detailed explanations and optimized solutions. Ideal for candidates aiming to improve both confidence and performance in coding interviews."
  },
  {
    id: 2,
    title: "Atomic Habits",
    url: "https://m.media-amazon.com/images/I/81ANaVZk5LL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 39,
    salePrice: null,
    rating: 5,
    description:
      "Atomic Habits explores how small, consistent changes can lead to remarkable long-term results. James Clear explains the science behind habit formation and how to break bad habits while building better ones. The book provides practical frameworks and real-life examples that are easy to apply. A powerful guide for personal growth, productivity, and self-discipline."
  },
  {
    id: 3,
    title: "Can't Hurt Me",
    url: "https://m.media-amazon.com/images/I/81gTRv2HXrL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 29,
    salePrice: null,
    rating: 5,
    description:
      "Can't Hurt Me is a raw and intense memoir by David Goggins that focuses on mental toughness and resilience. The book shares his journey from a difficult childhood to becoming an elite endurance athlete. Through personal stories, it challenges readers to push past self-imposed limits. A motivating read for those seeking discipline, accountability, and inner strength."
  },
  {
    id: 4,
    title: "Deep Work",
    url: "https://m.media-amazon.com/images/I/91nujEwIpYL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 44,
    salePrice: 19,
    rating: 4.5,
    description:
      "Deep Work examines the importance of focused, distraction-free work in an increasingly noisy world. Cal Newport explains how deep concentration leads to higher productivity and better results. The book offers practical strategies to build focus and reduce shallow work. Ideal for professionals seeking meaningful and high-impact output."
  },
  {
    id: 5,
    title: "The 10X Rule",
    url: "https://m.media-amazon.com/images/I/71hjq42hvGL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 32,
    salePrice: null,
    rating: 5,
    description:
      "The 10X Rule introduces a mindset focused on massive action and high goals. Grant Cardone argues that success requires effort far beyond average expectations. The book combines motivation with practical advice on business, sales, and personal ambition. Best suited for readers aiming to think bigger and act more decisively."
  },
  {
    id: 6,
    title: "Sell Or Be Sold",
    url: "https://m.media-amazon.com/images/I/616OvChM3RL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 70,
    salePrice: 12.5,
    rating: 5,
    description:
      "Sell Or Be Sold focuses on the idea that selling is a fundamental life skill, not just a business tool. Grant Cardone explains how persuasion, confidence, and communication impact everyday success. The book offers actionable sales techniques and mindset shifts. Ideal for professionals, entrepreneurs, and anyone wanting to influence effectively."
  },
  {
    id: 7,
    title: "Rich Dad Poor Dad",
    url: "https://m.media-amazon.com/images/I/81bsw6fnUiL.jpg",
    originalPrice: 11,
    salePrice: 10,
    rating: 4,
    description:
      "Rich Dad Poor Dad contrasts two different approaches to money, work, and financial education. Robert Kiyosaki shares lessons learned from his two father figures with opposing mindsets. The book emphasizes assets, financial independence, and long-term thinking. A classic introduction to personal finance and wealth building."
  },
  {
    id: 8,
    title: "Cashflow Quadrant",
    url: "https://m.media-amazon.com/images/I/71+SWQ6xj1L._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 38,
    salePrice: 17.95,
    rating: 4.5,
    description:
      "Cashflow Quadrant expands on financial concepts introduced in Rich Dad Poor Dad. It explains the four ways people earn income: employee, self-employed, business owner, and investor. The book focuses on shifting mindset toward financial freedom. Suitable for readers interested in entrepreneurship and investing."
  },
  {
    id: 9,
    title: "48 Laws of Power Summary",
    url: "https://m.media-amazon.com/images/I/611X8GI7hpL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 35,
    salePrice: 19.95,
    rating: 4.5,
    description:
      "This summary presents the core ideas from The 48 Laws of Power in a concise format. It explores strategies related to influence, authority, and human behavior. Each law is explained with historical context and practical insight. A fast-paced overview for readers interested in power dynamics."
  },
  {
    id: 10,
    title: "The 5 Second Rule",
    url: "https://m.media-amazon.com/images/I/91wOERyhh7L._UF1000,1000_QL80_.jpg",
    originalPrice: 40,
    salePrice: null,
    rating: 5,
    description:
      "The 5 Second Rule introduces a simple technique to overcome hesitation and self-doubt. Mel Robbins explains how counting down from five can trigger action and break negative habits. The book blends psychology with practical exercises. Ideal for improving confidence, motivation, and decision-making."
  },
  {
    id: 11,
    title: "How to Win Friends & Influence People",
    url: "https://m.media-amazon.com/images/I/71vK0WVQ4rL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 20,
    rating: 5,
    description:
      "How to Win Friends & Influence People is a timeless guide to communication and interpersonal skills. Dale Carnegie outlines principles for building trust, empathy, and influence. The book uses real-world examples to demonstrate effective human interaction. A must-read for leadership, sales, and personal development."
  },
  {
    id: 12,
    title: "Mastery",
    url: "https://m.media-amazon.com/images/I/51V3121nmkL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 12.95,
    rating: 4.5,
    description:
      "Mastery explores the path to achieving excellence in any field. Robert Greene combines historical examples with modern research on learning and creativity. The book emphasizes patience, deliberate practice, and long-term vision. Ideal for readers committed to deep skill development and lifelong growth."
  },
];
